import React from "react";
import Header from "../components/Header";
import TitleBar from "../components/TitleBar";
import Footer from "../components/Footer";
import SideBar from "../components/SideBar";
import MenuMobile from "../components/MenuMobile";
import "../styles/About.css";
import IconCloud from "../components/IconCloud";
function About() {
  return (
    <body>
      <TitleBar />
      <section className="flex-container">
        <section className="main-container">
          <Header />
          <MenuMobile />
          <main className="main-wrapper about">
            <div className="about-container">
              <span className="span-tag html">{"<html>"}</span>
              <br />
              <span className="span-tag body">{"<body>"}</span>
              <br />
              <span className="span-tag content">{"<h1>"}</span>
              <h1 className="title-about">Olá,</h1>
              <span className="span-tag content">{"</h1>"}</span>
              <br />
              <span className="span-tag content">{"<p>"}</span>
              <p className="text-about">
                Meu nome é{" "}
                <span className="span-highlight">Carlos Tavares</span> e adoro
                solucionar problemas através dos códigos. Sou formado em
                Direito, mas estou em transição de carreira, atualmente
                aplicando meus conhecimentos em Desenvolvimento{" "}
                <span className="span-highlight">Web Full Stack </span>
                em projetos para aprimorar minhas habilidades.
                
              </p>
              
              <p className="text-about">
                Meu objetivo é poder ajudar a melhorar a vida das pessoas,
                desenvolvendo aplicações que sejam{" "}
                <span className="span-highlight">acessíveis e funcionais</span>.
                Para isso, estou sofisticando meus conhecimentos em outras linguagens de programação,
                estudando no momento Java, por ser uma linguagem mais robusta e completa, com todo o suporte da Gama Academy.
              </p>
              <p className="text-about last">
                AS habilidades relevantes incluem:{" "}
                <span className="span-highlight">
                  Html, CSS, JavaScript, React, ContextAPI, Hooks, Git/Github, Spring Boot em Java.
          
                </span>
              </p>
              <span className="span-tag content">{"</p>"}</span>
              <br />
              <span className="span-tag body">{"</body>"}</span>
              <br />
              <span className="span-tag html">{"</html>"}</span>
            </div>
            <IconCloud />
          </main>
        </section>
        <SideBar />
      </section>
      <Footer />
    </body>
  );
}

export default About;
